import { For, Show } from "solid-js";
import { Post } from "../Post";
import { usePostsContext } from "../../../Provider/context";
import { Group } from "~/components/ui/group";
import { TextField, TextFieldInput } from "~/components/ui/text-field";
import { Pagination, PaginationEllipsis, PaginationItem, PaginationItems, PaginationNext, PaginationPrevious } from "~/components/ui/pagination";
import { PostGrid } from "../../../components/PostGrid";
import { Badge } from "~/components/ui/badge";

export function Root() {

	let main: HTMLDivElement | undefined;

	const {
		page,
		posts,
		search,
		setSearch,
		selected,
		setPage,
		pageCount,
		isSelected,
		topics,
		topic,
		setTopic,
	} = usePostsContext();

	return (
		<div ref={main}>
			<Show 
				when={!isSelected()}
				fallback={<Post post={selected()!} />}
			>
				<div class="w-full flex flex-col gap-6 mb-6">
					<TextField>
						<TextFieldInput
							class="lg:w-[300px]"
							type="text"
							placeholder="Zoeken naar posts..."
							value={search()}
							onInput={(event) => setSearch(event.currentTarget.value)}
						/>
					</TextField>
					<Show
						when={topics().length > 0}
					>
						<Group>
							<Badge
								variant={!topic() ? "filled" : "outline"}
								onClick={() => setTopic(undefined)}
								class="cursor-pointer select-none"
							>
								Alles
							</Badge>
							<For
								each={topics()}
							>
								{(curr) => (
									<Badge
										variant={topic() === curr.id ? "filled" : "outline"}
										onClick={() => setTopic(curr.id)}
										class="cursor-pointer select-none"
									>
										{curr.name}
									</Badge>
								)}
							</For>
							<Badge
								variant={topic() === "rest" ? "filled" : "outline"}
								onClick={() => setTopic("rest")}
								class="cursor-pointer select-none"
							>
								Overig
							</Badge>
						</Group>
					</Show>
				</div>
				<PostGrid posts={posts} />
				<Group class="mt-4" justify="center">
					<Pagination
						page={page()}
						count={pageCount()}
						onPageChange={setPage}
						ellipsisComponent={() => <PaginationEllipsis />}
						itemComponent={(props) => (
							<PaginationItem page={props.page}>
								{props.page}
							</PaginationItem>
						)}
					>
						<PaginationPrevious />
						<PaginationItems />
						<PaginationNext />
					</Pagination>
				</Group>
			</Show>
		</div>
	);
}